export default interface IEnquiry {
    name: string;
    phone: string;
    email: string;
    message: string;
}

export const NewEnquiry = (): IEnquiry => ({
    name: "",
    phone: "",
    email: "",
    message: ""
});